import dictionary from '@rexmas/rexmas-shared/lib/conf/dictionary/es';
import { logout } from '../actionCreators/session';
import { showErrorAction, dismissErrorAction } from '../actionCreators/errors';

export const showError = (error) => (dispatch) => dispatch(showErrorAction(error));

export const kickError = () => (dispatch, getState) => {
  const { errorsReducer } = getState();
  if (!errorsReducer.hasError) {
    dispatch(showError({
      title: dictionary.general.disconnection,
      message: dictionary.errors.kick,
      onPress: () => {
        dispatch(logout());
      },
    }));
  }
};

export const networkError = () => (dispatch, getState) => {
  const { errorsReducer } = getState();
  if (!errorsReducer.hasError) {
    dispatch(showError({
      title: dictionary.general.notice,
      message: dictionary.errors.noNetwork,
    }));
  }
};

export const dismissError = () => (dispatch) => dispatch(dismissErrorAction());
